function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import { borderRadius } from 'styled-system';
import ssPropTypes from '@styled-system/prop-types';
import { themed } from '../utils/system';
import { Box } from '../index';
var Image = styled(Box)(_templateObject(), themed('Image'), borderRadius);
Image.propTypes = _extends({}, ssPropTypes.borderRadius);
Image.defaultProps = {
  as: 'img'
};
Image.displayName = 'Image';
export default Image;